import { Shipment } from './shipmentTypes';

// eslint-disable-next-line import/prefer-default-export
export const mockShipments: Shipment[] = [
  {
    branch: '1170',
    carrier: 'GEISPARCEL',
    deliveryTypes: ['B2C', 'B2B'],
    shippingListId: 210070,
    numberOfOrders: 2,
    shippingListUrl: 'https://alza.com/shiping-list/210070',
  },
  {
    branch: '1238',
    carrier: 'GEISPARCEL',
    deliveryTypes: ['Branch'],
    shippingListId: 210071,
    numberOfOrders: 1,
    shippingListUrl: 'https://alza.com/shiping-list/210071',
  },
];
